// Logo Slider
$(document).ready(function(){
  $('.trusted_slider').slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1,
    speed: 5000,
    dots: false,
    arrows: false,
    cssEase: 'linear',
    waitForAnimate: false,
    pauseOnFocus: false, 
    pauseOnHover: false,
    responsive: [
        {
        breakpoint: 1400,
            settings: {
                slidesToShow: 5,
            }
        },
        {
        breakpoint: 991,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
            }
        },
        {
        breakpoint: 767,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
        breakpoint: 576,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },      
    ]
  });
});

// Product
$('.product_slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    arrows: true,
    dots: false,
    responsive: [
    {
        breakpoint: 992,
        settings: {
            slidesToShow: 2,
        }
    },
    {
        breakpoint: 576,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
    },
    ]
});

// Gallery Slider
// $(document).ready(function(){
//   $('.gallery_slider').slick({
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 1,
//     speed: 5000,
//     dots: false,
//     arrows: false,
//     cssEase: 'linear',
//     waitForAnimate: false,
//     pauseOnFocus: false, 
//     pauseOnHover: false,
//     responsive: [
//     {
//         breakpoint: 992,
//         settings: {
//             slidesToShow: 3,
//         }
//     },
//     {
//         breakpoint: 768,
//         settings: {
//             slidesToShow: 2,
//             slidesToScroll: 1
//         }
//     },
//     {
//         breakpoint: 576,
//         settings: {
//             slidesToShow: 1.2,
//             slidesToScroll: 1
//         }
//     },
//     ]
//   });
// });

// Scroll to Top
$(window).scroll(function() {
    if ($(this).scrollTop() >= 50) {
        $('#return-to-top').fadeIn(200);
    } else {
        $('#return-to-top').fadeOut(200);
    }
});
$('#return-to-top').click(function() {
    $('body,html').animate({
        scrollTop : 0
    }, 500);
});